module.exports = __webpack_public_path__ + "img/emirates-logo.e3494166.png";